import styled from 'styled-components';

import Checkbox from '../../Checkbox';

export const StyledCheckbox = styled(Checkbox)`
  border-radius: 0.3rem;
`;
